// Mobile Call FAB Component
// Floating action button for quick calling on mobile

import { PhoneCall } from 'lucide-react';

const MobileCallFAB = ({ clientPhone }) => {
  if (!clientPhone) return null;

  return (
    <div className="lg:hidden fixed bottom-6 right-6 z-40">
      <a 
        href={`tel:${clientPhone.replace(/\D/g, '')}`}
        data-testid="fab-call-btn"
      >
        <button 
          className="w-14 h-14 bg-emerald-500 hover:bg-emerald-600 rounded-full shadow-lg flex items-center justify-center text-white transition-all active:scale-95"
          style={{ boxShadow: '0 4px 14px rgba(16, 185, 129, 0.4)' }}
        >
          <PhoneCall className="w-6 h-6" />
        </button>
      </a>
    </div>
  );
};

export default MobileCallFAB;
